import React, { useState, useEffect } from "react";

const ChirpStackStep1 = ({ onComplete }) => {
  const [applications, setApplications] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState("");
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchChirpStackApplications();
  }, []);

  const fetchChirpStackApplications = async () => {
    setLoading(true);
    setError("");
    
    try {
      const response = await fetch("/api/admin/sensors/chirpstack/applications", {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        setApplications(data.result || []);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Fout bij het ophalen van applications");
      }
    } catch (error) {
      console.error("Fetch fout:", error);
      setError("Er is een fout opgetreden bij het ophalen van ChirpStack applications");
    } finally {
      setLoading(false);
    }
  };

  const fetchChirpStackDevices = async (applicationId) => {
    setLoadingDevices(true);
    setError("");
    
    try {
      const response = await fetch(`/api/admin/sensors/chirpstack/devices?applicationId=${applicationId}`, {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        setDevices(data.result || []);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Fout bij het ophalen van devices");
      }
    } catch (error) {
      console.error("Fetch fout:", error);
      setError("Er is een fout opgetreden bij het ophalen van ChirpStack devices");
    } finally {
      setLoadingDevices(false);
    }
  };

  const handleApplicationSelect = (applicationId) => {
    setSelectedApplication(applicationId);
    setDevices([]);
    if (applicationId) {
      fetchChirpStackDevices(applicationId);
    }
  };

  const handleContinue = () => {
    if (devices.length > 0) {
      onComplete(devices);
    }
  };

  return (
    <div>
      <h4>Stap 1: ChirpStack Applicatie & Devices</h4>
      <p>Selecteer eerst een ChirpStack applicatie om devices op te halen.</p>

      {loading && (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin fa-2x"></i>
          <p>Bezig met ophalen van applicaties...</p>
        </div>
      )}

      {error && (
        <div className="alert alert-danger">
          <strong>Fout:</strong> {error}
          <br />
          <button 
            className="btn btn-sm btn-warning" 
            onClick={fetchChirpStackApplications}
          >
            Opnieuw proberen
          </button>
        </div>
      )}

      {!loading && !error && applications.length === 0 && (
        <div className="alert alert-info">
          <strong>Geen applicaties gevonden.</strong>
          <br />
          Controleer je ChirpStack instellingen en probeer opnieuw.
          <br />
          <button 
            className="btn btn-sm btn-primary" 
            onClick={fetchChirpStackApplications}
          >
            Opnieuw laden
          </button>
        </div>
      )}

      {!loading && applications.length > 0 && (
        <div>
          <div className="alert alert-success">
            <strong>Succesvol!</strong> {applications.length} applicatie(s) gevonden in ChirpStack.
          </div>

          <div className="form-group">
            <label><strong>Selecteer een applicatie:</strong></label>
            <select 
              className="form-control"
              value={selectedApplication}
              onChange={(e) => handleApplicationSelect(e.target.value)}
            >
              <option value="">-- Kies een applicatie --</option>
              {applications.map((app, index) => (
                <option key={index} value={app.id}>
                  {app.name} ({app.id})
                </option>
              ))}
            </select>
          </div>

          {loadingDevices && (
            <div className="text-center">
              <i className="fa fa-spinner fa-spin"></i>
              <p>Bezig met ophalen van devices...</p>
            </div>
          )}

          {selectedApplication && !loadingDevices && devices.length === 0 && (
            <div className="alert alert-warning">
              <strong>Geen devices gevonden</strong> in deze applicatie.
            </div>
          )}

          {devices.length > 0 && (
            <div>
              <div className="alert alert-info">
                <strong>Gevonden:</strong> {devices.length} device(s) in applicatie.
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Device EUI</th>
                      <th>Naam</th>
                      <th>Beschrijving</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devices.slice(0, 10).map((device, index) => (
                      <tr key={index}>
                        <td><code>{device.devEui}</code></td>
                        <td>{device.name || "-"}</td>
                        <td>{device.description || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {devices.length > 10 && (
                  <p className="text-muted">
                    ... en {devices.length - 10} meer devices
                  </p>
                )}
              </div>

              <div className="pull-right">
                <button 
                  className="btn btn-primary btn-lg"
                  onClick={handleContinue}
                >
                  Doorgaan naar selectie <i className="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ChirpStackStep1;